import httpClient from './httpClient';

const prefix = 'car'

export default {
    async getStatusCarTypes (body) {
        const data = await httpClient({ requiresAuth: true }).post(`${prefix}/getStatusCarTypes` , body)
        return data
    },
    async getBookingDetailsByDriver(driver_id , time_start , time_end) {
        const data = await httpClient({ requiresAuth: true }).post(`${prefix}/getBookingDetailsByDriver` , {
            driver_id:driver_id,
            time_start:time_start,
            time_end:time_end
        })
        return data
    },
    async getCarByDriver (driver_id) {
        const {data} = await httpClient({ requiresAuth: true }).get(`${prefix}/getCarByDriver/${driver_id}`)
        return data
      },
    async getNotificationCar () {
        const {data} = await httpClient({ requiresAuth: true }).get(`${prefix}/getCarExpireNotification`)
        return data
    },
    async isReadNotificationCar () {    
        const {data} = await httpClient({ requiresAuth: true }).get(`${prefix}/cars/is_read`)
        return data
    },
    async isReadNotificationCarId (id,expireType) {
        console.log('case', id)
        const {data} = await httpClient({ requiresAuth: true }).get(`${prefix}/cars/is_read/${id}/${expireType}`)
        return data
    },
}